import { createContext, useContext } from 'react'
import { IThemeValue } from './section.model'

export const SectionThemeContext = createContext<IThemeValue>('default')

export const useSectionTheme = (): IThemeValue | null => useContext(SectionThemeContext)
